module.exports = __webpack_public_path__ + "img/25.f3061b77.svg";